import { render, staticRenderFns } from "./VideoTitle.vue?vue&type=template&id=001b58d0&scoped=true&"
import script from "./VideoTitle.vue?vue&type=script&lang=js&"
export * from "./VideoTitle.vue?vue&type=script&lang=js&"
import style0 from "./VideoTitle.vue?vue&type=style&index=0&id=001b58d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b58d0",
  null
  
)

export default component.exports